import { CombinedGraphQLErrors } from "@apollo/client";

import { isRecord } from "@kazoohr/helpers";
import { TFunction } from "@kazoohr/internationalization";

/**
 * Tries to parse the supplied `error` value as a `KazooError`
 * and extracts the already-translated message from its metadata, or the default
 * message you supply if that can't be achieved.
 *
 * @param defaultMessage The message that will be returned if the error doesn't include a translation string. Usually this should be wrapped in TFunction.
 * @param error The error that may or may not be a KazooError
 */
export function extractMessageFromKazooError(
  defaultMessage: string,
  error: unknown,
  t: TFunction
): string {
  let message;
  let translationValues: Record<string, unknown> | undefined;
  const graphQLErrors = CombinedGraphQLErrors.is(error) ? error.errors : [];
  message = graphQLErrors.find((gqlErr) => !!gqlErr?.extensions?.translation)
    ?.extensions?.translation;

  if (!message) {
    const graphQLError = graphQLErrors.find(
      (gqlErr) => !!gqlErr?.extensions?.translationKey
    );
    if (graphQLError) {
      message = graphQLError.extensions?.translationKey;
      const rawValues = graphQLError.extensions?.translationValues;
      translationValues = isRecord(rawValues) ? rawValues : {};
    }
  }
  if (message) {
    return t(String(message), { ...translationValues });
  }
  return defaultMessage;
}
